import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api";
import { HotelShopPriceLoading } from "@tenant/hotels";
import clsx from "clsx";
import { useHotelShopPriceSection } from "./hooks";
import defaultStyles from "./HotelShopPrice.module.scss";

export interface HotelShopPriceProps extends PlatformComponentProps {
  hotel: Lodging;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelShopPrice;

export const HotelShopPrice = (props: HotelShopPriceProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className } = props;

  const viewProps = useHotelShopPriceSection(props);
  return (
    <div className={clsx(block, className)}>
      {!viewProps.isLoading ? (
        viewProps.isAvailable ? (
          <>
            <div className={cn("starting-text")}>{viewProps.startingAt}</div>
            <div className={cn("price-container")}>
              <span className={cn("price")}>{viewProps.price}</span>
              <span className={cn("per-night-text")}>
                {" "}
                {viewProps.perNightText}
              </span>
            </div>
          </>
        ) : (
          <div className={cn("unavailable")}>{viewProps.unavailable}</div>
        )
      ) : (
        <HotelShopPriceLoading />
      )}
    </div>
  );
};
